<template>
  <ion-row
    class="-span ion-align-items-center ion-justify-content-end ion-margin-top ion-padding-top"
  >
    <ion-col size="auto"> Exklusiv für <b>ARAG</b> Kunden </ion-col>
    <ion-col size="auto">
      <img
        width="40"
        height="40"
        src="@/assets/img/arag_logo.png"
        alt="ARAG Logo"
      />
    </ion-col>
  </ion-row>
</template>

<script>
import { IonRow, IonCol } from "@ionic/vue";

export default {
  components: {
    IonRow,
    IonCol,
  },
};
</script>

<style></style>
